module.exports = __webpack_public_path__ + "img/pic8.6d21bbe9.png";